import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISHES_AVAILABLE_FOR_QA_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS } from '../redux/action-types'

const useDishesAvailableForQaCountsLazyQuery = ({
  wasDoneInPreviousTwoWeeks,
}) => {
  const dispatch = useDispatch()

  const {
    availableForQaCounts: data,
    isAvailableForQaCountsLoading: isLoading,
    availableForQaCountsError: error,
  } = useSelector(store => store.dishes.dishes)

  const fetch = useCallback(
    menuId =>
      apolloService.query({
        query: DISHES_AVAILABLE_FOR_QA_COUNTS_QUERY,
        variables: {
          menuId,
          filters: {
            wasDoneInPreviousTwoWeeks,
          },
        },
        dispatch,
        action: FETCH_DISHES_AVAILABLE_FOR_QA_COUNTS,
      }),
    [dispatch, wasDoneInPreviousTwoWeeks],
  )

  return [fetch, { isLoading, error, data }]
}

export default useDishesAvailableForQaCountsLazyQuery
